export default "__VITE_ASSET__784f723a__"